import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { Slot } from '../models/Slot';

export class SlotMapper {
  private readonly encoder: GQLIdEncoder;

  constructor() {
    this.encoder = new GQLIdEncoder();
  }

  mapToDomain(data: any): Slot {
    const id = this.encoder.decode(data.id);
    let reportId = null;
    if (data.latestReportId) {
      reportId = this.encoder.decode(data.latestReportId);
    }

    return new Slot(id, data.id, data.name, data.instancesFailed, data.instancesPassed, reportId);
  }
}
